import globalConfig from '../../utiles/globalConfig';
import diffType from './_type';

const page = {
  home: 'home',
  selectProductPage: 'select-product-page',
  pay: 'pay-page',
  vip: 'vip-page',
  bankInfo: 'bank-detail-page',
  result: `${
    globalConfig.getHrefParam('result') == 1
      ? 'result-succ-page'
      : 'result-fail-page'
  }`,
  browserPay: 'wait-page',
  web: 'web-ready-page'
};

export default {
  event: {
    'j-select-role-confirm': [
      {
        type: 'click',
        event: 'click-select-role-confirm'
      }
    ],
    'j-select-role-confirm-popup': [
      {
        type: 'click',
        event: 'click-select-role-confirm-popup'
      }
    ],
    'j-cancel-choose-coupon': [
      {
        type: 'click',
        event: 'click-cancel-choose-coupon'
      }
    ],
    'j-login-btn': [
      {
        type: 'click',
        event: 'click-login-center-login'
      }
    ],
    'j-add-to-home': [
      {
        type: 'click',
        event: 'click-add-to-home'
      }
    ],
    'j-about-tips': [
      {
        type: 'click',
        event: 'click-about-tips'
      }
    ],
    'j-facebook-login-btn': [
      {
        type: 'click',
        event: 'click-facebook-login-btn',
        newPage: true
      }
    ],
    'j-twitter-login-btn': [
      {
        type: 'click',
        event: 'click-twitter-login-btn',
        newPage: true
      }
    ],
    'j-line-login-btn': [
      {
        type: 'click',
        event: 'click-line-login-btn',
        newPage: true
      }
    ],
    'j-googleplay-login-btn': [
      {
        type: 'click',
        event: 'click-google-login-btn',
        newPage: true
      }
    ],
    'j-naver-login-btn': [
      {
        type: 'click',
        event: 'click-naver-login-btn',
        newPage: true
      }
    ],
    'j-vk-login-btn': [
      {
        type: 'click',
        event: 'click-vk-login-btn',
        newPage: true
      }
    ],
    'j-apple-login-btn': [
      {
        type: 'click',
        event: 'click-apple-login-btn',
        newPage: true
      }
    ],
    'j-uid-token-login-btn': [
      {
        type: 'click',
        event: 'click-uid-token-login-btn',
        newPage: true
      }
    ],
    'j-again-role': [
      {
        type: 'click',
        event: 'click-again-role-btn'
      }
    ],
    'j-select-role-confirm-popuo': [
      {
        type: 'click',
        event: 'click-select-role-confirm-btn-popup'
      }
    ],
    'j-select-role-confirm': [
      {
        type: 'click',
        event: 'click-select-role-confirm-btn'
      }
    ],
    'j-click-logout': [
      {
        type: 'click',
        event: 'click-logout'
      }
    ],
    'j-select-server-ele': [
      {
        type: 'change',
        event: 'click-update-server'
      },
      {
        type: 'focus',
        event: 'click-open-server-list-btn'
      }
    ],
    'j-select-role-ele': [
      {
        type: 'change',
        event: 'click-update-role'
      },
      {
        type: 'focus',
        event: 'click-open-role-list-btn'
      }
    ],
    'j-select-lang': [
      {
        type: 'click',
        event: 'click-select-lang'
      }
    ],
    'j-select-lang-item': [
      {
        type: 'click',
        event: 'click-select-lang-item'
      }
    ],
    'j-select-product': [
      {
        type: 'click',
        event: 'click-update-product'
      }
    ],
    'j-select-area': [
      {
        type: 'click',
        event: 'click-update-area'
      }
    ],
    'j-area-dcount': [
      {
        type: 'click',
        event: 'click-open-channel-list-btn'
      }
    ],
    'j-select-payType': [
      {
        type: 'click',
        event: 'click-update-channel'
      }
    ],
    'j-click-more-channel': [
      {
        type: 'click',
        event: 'click-more-channel'
      }
    ],
    'j-go-feeback-btn': [
      {
        type: 'click',
        event: 'click-go-feeback-btn'
      }
    ],
    'j-restore-btn': [
      {
        type: 'click',
        event: 'click-go-restore-btn',
        newPage: true
      }
    ],
    'j-service-float-btn': [
      {
        type: 'click',
        event: 'click-service-float-btn',
        newPage: true
      }
    ],
    'j-select-coupon-entry': [
      {
        type: 'click',
        event: 'click-select-coupon-entry',
        pageName: page.pay
      }
    ],
    'j-select-coupon-item': [
      {
        type: 'click',
        event: 'click-select-coupon-item',
        pageName: page.pay
      }
    ],
    'j-click-coupon-item-use': [
      {
        type: 'click',
        event: 'click-coupon-item-use'
      }
    ],
    'j-click-coupon-close': [
      {
        type: 'click',
        event: 'click-coupon-popup-close'
      }
    ],
    'j-click-coupon-confirm-sure': [
      {
        type: 'click',
        event: 'click-coupon-confirm-sure'
      }
    ],
    'j-click-coupon-confirm-cancel': [
      {
        type: 'click',
        event: 'click-coupon-confirm-cancel'
      }
    ],
    'j-role-switch': [
      {
        type: 'click',
        event: 'click-role-switch-btn'
      }
    ],
    'j-entry-coupon': [
      {
        type: 'click',
        event: 'click-entry-coupon-btn'
      }
    ],
    'j-entry-vip': [
      {
        type: 'click',
        event: 'click-entry-vip-btn'
      }
    ],
    'j-entry-z-bit': [
      {
        type: 'click',
        event: 'click-entry-z-bit-btn'
      }
    ],
    'j-entry-more-coupon': [
      {
        type: 'click',
        event: 'click-entry-more-coupon-btn'
      }
    ],
    'j-slide-banner': [
      {
        type: 'click',
        event: 'click-slide-banner'
      }
    ],
    'j-click-my-coupon': [
      {
        type: 'click'
      }
    ],
    'j-click-vip-score': [
      {
        type: 'click',
        event: 'click-vip-score'
      }
    ],
    'j-ask-wallet': [
      {
        type: 'click',
        event: 'click-ask-wallet'
      }
    ],
    'j-click-back': [
      {
        type: 'click',
        event: 'click-back-home'
      }
    ],
    'j-click-vip-my-coupon': [
      {
        type: 'click',
        event: 'click-vip-my-coupon',
        pageName: page.vip
      }
    ],
    'j-click-vip-ratio': [
      {
        type: 'click',
        event: 'click-vip-ratio',
        pageName: page.vip
      }
    ],
    'j-click-vip-coupon-limit-ratio': [
      {
        type: 'click',
        event: 'click-vip-coupon-limit-ratio',
        pageName: page.vip
      }
    ],
    'j-credit-card-item': [
      {
        type: 'click',
        event: 'click-credit-card-choose',
        pageName: page.event
      }
    ],
    submitLoading: [
      {
        type: 'click',
        event: 'click-submit-btn',
        newPage: true,
        pageName: page.pay
      }
    ],
    'j-submit-nbtn': [
      {
        type: 'click',
        event: 'click-submit-btn',
        newPage: true
      }
    ],
    productList: [
      {
        type: 'click',
        event: 'show-product-list'
      }
    ]
  },
  enter: {
    payPage: { event: page.pay }
  },
  observer: {
    submitLoading: {
      pre: false,
      now: true,
      action: 'event',
      type: 'data',
      page: 'payPage',
      diffType: diffType.equal
    },
    productList: {
      action: 'event',
      type: 'computed',
      page: 'webSelectProduct',
      diffType: diffType.noEmptyArrayPre
    }
  },
  router: {
    home: { event: page.home },
    bankInfo: { event: page.bankInfo },
    result: {
      event: page.result
    },
    pay: { event: page.pay }
  }
};
